/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum EquipmentFirmwareFamily {

    Unknown = 'Unknown',

    Stock = 'Stock',

    Vnish = 'Vnish',

    PitBit = 'PitBit'
}

